<template>
  <div>
    <div class="card groupcard mt-4 mb-4 card-layout">
      <div class="row">
        <div class="col border-right-color" v-if="!branchLogIn">
          <h4 v-if="partnerdetail.country.toLowerCase() == 'india'">Financial Performance</h4>
          <hr />
          <div class="row" v-if="partnerdetail.country.toLowerCase() == 'india'">
            <div class="col">
              <h2>Assets To Liability Ratio</h2>
              <h2>Average Capital Percentage</h2>
              <h2>Debt To Asses Ratio</h2>
              <h2>Debt Outstanding</h2>
            </div>

            <div class="col">
              <h2>{{financialData.assetsToLiabilityratio}}</h2>
              <h2>{{financialData.averageCapitalPercentage}}</h2>
              <h2>{{financialData.debtOutStanding}}</h2>
              <h2>{{financialData.debtToAssesRatio}}</h2>
            </div>
          </div>
          <br />
          <h4>Financial Year Performances</h4>
          <hr />
          <span v-for="(res, i) in financialValue" :key="i">
            <h3>Year &nbsp;&nbsp;({{res.year}})</h3>
            <div class="row">
              <div class="col-6">
                <h2 v-if="partnerdetail.country.toLowerCase() == 'india'">Assets</h2>
                <h2 v-if="partnerdetail.country.toLowerCase() == 'india'">Gross Profit</h2>
                <h2 v-if="partnerdetail.country.toLowerCase() == 'india'">Net Profit</h2>
                <h2 v-if="partnerdetail.country.toLowerCase() == 'india'">ROA</h2>
                <h2 v-if="partnerdetail.country.toLowerCase() == 'india'">ROCE</h2>
                <h2>Turnover</h2>
                <h2 v-if="res.balanceSheetDocument">BalanceSheet Attachment</h2>
                <h2 v-if="res.itrAttachment">ITR Attachment</h2>
              </div>
              <div class="col-6">
                <h2 v-if="partnerdetail.country.toLowerCase() == 'india'">{{getValue(res.assets)}}</h2>
                <h2 v-if="partnerdetail.country.toLowerCase() == 'india'">{{getValue(res.grossProfit)}}</h2>
                <h2 v-if="partnerdetail.country.toLowerCase() == 'india'">{{getValue(res.netProfit)}}</h2>
                <h2 v-if="partnerdetail.country.toLowerCase() == 'india'">{{getValue(res.roa)}}</h2>
                <h2 v-if="partnerdetail.country.toLowerCase() == 'india'">{{getValue(res.roce)}}</h2>
                <h2>{{partnerdetail.currencyType.shortDesc}} {{getValue(res.turnover)}} {{partnerdetail.currencyUnitType.shortDesc}}</h2>
                <h2 v-if="res.balanceSheetDocument">
                  <a
                    href="#"
                    @click="showAttachFile(res.balanceSheetDocument)"
                  >{{document(res.balanceSheetDocument)}}</a>
                </h2>
                <h2 v-if="res.itrAttachment">
                  <a
                    href="#"
                    @click="showAttachFile(res.itrAttachment)"
                  >{{document(res.itrAttachment)}}</a>
                </h2>
              </div>
            </div>
          </span>
          <span v-if="financialValue.length == 0">
            <h2>No Financial record available</h2>
          </span>
        </div>
        <div class="col">
          <h4 v-if="partnerdetail.country.toLowerCase() == 'india' || 
          (partnerdetail.partnerCategory == 'B')">Financial Strength</h4>
          <hr />
          <div class="row mt-3" v-if="partnerdetail.country.toLowerCase() == 'india' || 
          (partnerdetail.partnerCategory == 'B')">
            <div class="col-6">
              <h5 class="m-0 p-0 pb-3">Does your firm has any Financial Banker or Guarantor ?</h5>
            </div>
            <div class="col-6">
              <div
                v-if="financialStrength.financialBacker == 'Y'"
                @click="showAttachFile(financialStrength.backerDocument)"
              >
                <a href="#">{{document(financialStrength.backerDocument)}}</a>
              </div>
              <div v-else>
                <h2>No</h2>
              </div>
            </div>
          </div>
          <h5 v-if="financialStrength.financialBacker == 'Y'">Financial Bank Details</h5>
          <div class="bankScroll">
            <span v-for="(res, i) in financialStrength.bankers" :key="i">
              <h3>Bank Account Details - {{i+1}}</h3>
              <div class="row mt-3">
                <div class="col-6">
                  <h2>Banker Name</h2>
                  <h2>Banker Type</h2>
                  <h2>Contact Person Name</h2>
                  <h2>Designation</h2>
                  <h2>Email</h2>
                  <h2>Mobile Number</h2>
                  <h2>IFSC Code</h2>
                  <h2>Year Of Association</h2>
                </div>
                <div class="col-6">
                  <h2>{{res.bankerName}}</h2>
                  <h2>{{res.bankerTypeCode}}</h2>
                  <h2>{{res.contactPersonName}}</h2>
                  <h2>{{res.designation}}</h2>
                  <h2>{{res.email}}</h2>
                  <h2>{{res.mobileNumber}}</h2>
                  <h2>{{res.ifscCode}}</h2>
                  <h2>{{res.yearOFAssociation}}</h2>
                </div>
              </div>
            </span>
          </div>
          <br v-if="!branchLogIn" />
          <h4 v-if="!branchLogIn && partnerdetail.country.toLowerCase() == 'india'">Others</h4>
          <hr v-if="!branchLogIn" />
          <div class="row" v-if="!branchLogIn && partnerdetail.country.toLowerCase() == 'india'">
            <div class="col">
              <h2>Merger Details</h2>
            </div>
            <div class="col">
              <h2>{{financialmerge.mergerDetails}}</h2>
            </div>
          </div>
          <h5 class v-if="!branchLogIn && partnerdetail.country.toLowerCase() == 'india'">Ratings by any rating agency</h5>
          <div class="ratingScroll" v-if="!branchLogIn">
            <span v-for="(res, i) in financialOthers" :key="i">
              <h3 class="m-0 p-0">Ratings - {{i+1}}</h3>
              <div class="row">
                <div class="col-6">
                  <h2>Rating Agency</h2>
                  <h2>Rating</h2>
                  <h2>Attachments</h2>
                </div>
                <div class="col-6">
                  <h2>{{res.ratingAgencyCode}}</h2>
                  <h2>{{res.agencyRating}}</h2>
                  <a
                    href="#"
                    @click="showAttachFile(res.ratingDocumentId)"
                  >{{document(res.ratingDocumentId)}}</a>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropDown from "../../widgets/DropDown";
import TextInput from "../../widgets/TextInput";
import multiSelect from "vue-multi-select";
import Radio from "../../widgets/RadioInput";
import FileUploader from "../../widgets/FileUploader.vue";
import moment from "moment";
import { OnBoardingServices } from "../../services/onBoardingService";
const OnBoardingService = new OnBoardingServices();
import { SummaryServices } from "../../services/summaryService";
const SummaryService = new SummaryServices();
export default {
  components: {
    "w-dropdown": DropDown,
    "w-text-input": TextInput,
    "w-radio": Radio,
    FileUploader,
    multiSelect
  },
  created() {
    this.getFinancialData();
  },

  data() {
    return {
      module: "financial",
      financialData: "",
      financialValue: [],
      financialStrength: "",
      financialOthers: "",
      financialmerge: ""
    };
  },
  props: ["answerkey", "userid", "auditno", "branchLogIn","partnerdetail"],
  methods: {
    document(attachment) {
      if (attachment) {
        return attachment.split(/_(.+)/)[1];
      }
    },
    getValue(value) {
      if (value) {
        return value;
      } else {
        return "-";
      }
    },
    getFinancialData() {
      if (this.$router.currentRoute.name == "OnboardingPreview") {
        // ForOnboardPreview
        OnBoardingService.getContent(this.module, this.answerkey).then(resp => {
          this.financialData = resp.response.summary.financialPerformance;
          this.financialValue =
            resp.response.summary.financialPerformance.financialYearPerformances;
          this.financialStrength = resp.response.summary.financialStrength;
          this.financialmerge = resp.response.summary.others;
          this.financialOthers = resp.response.summary.others.ratings;
        });
      } else if (this.$router.currentRoute.name == "VendorDetails") {
        // ForOnboardPreview
        OnBoardingService.getContent(this.module, this.answerkey,true).then(resp => {
          this.financialData = resp.response.summary.financialPerformance;
          this.financialValue =
            resp.response.summary.financialPerformance.financialYearPerformances;
          this.financialStrength = resp.response.summary.financialStrength;
          this.financialmerge = resp.response.summary.others;
          this.financialOthers = resp.response.summary.others.ratings;
        });
      } else {
        // ForSummary
        SummaryService.getContent(
          this.module,
          this.answerkey,
          this.userid,
          this.auditno
        )
          .then(resp => {
            this.financialData = resp.response.summary.financialPerformance;
            this.financialValue =
              resp.response.summary.financialPerformance.financialYearPerformances;
            this.financialStrength = resp.response.summary.financialStrength;
            this.financialmerge = resp.response.summary.others;
            this.financialOthers = resp.response.summary.others.ratings;
          })
          .catch(err => {
            //   sessionStorage.clear();
            //alert("SESSION EXPIRED");
            // location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
          });
      }
    },
    showAttachFile(event) {
      if (event) {
        this.loading = true;
        SummaryService.downLoadDocument(event).then(res => {
          this.loading = false;
        });
      }
    }
  }
};
</script>

<style scoped>
.v-stepper__label {
  cursor: pointer;
}

.col-bg {
  background-color: white !important;
}

.percentage {
  font-size: 30px;
  font-weight: bold;
  color: #002d72;
}
.percentageText {
  font-size: 20px;
  line-height: 1.55;
  color: #002d72;
}
.card-img {
  height: 90px;
  margin: auto;
}
.groupcard {
  width: 90% !important;
  height: auto !important;
  padding: 40px;
  margin: 0 auto;
}
.cardText {
  margin-left: 10%;
  margin-right: 10%;
}
.cardDetails {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.2px;
  color: #272727;
}
.selectedbox {
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 45, 114, 0.3);
  border: solid 3px #002d72;
}
.textValue {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.52;
  letter-spacing: 0.21px;
  color: #333333;
  padding-left: 2%;
}
.financeText {
  font-size: 16px;
  font-weight: bold;
  color: #071b31;
  margin: 0;
  padding-left: 5%;
}
.addAccount {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.55;
  color: #003a78;
  padding-left: 5%;
}
h4 {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 0.18px;
  text-align: left;
  color: #272727;
}
h2 {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  padding-bottom: 1%;
  letter-spacing: 0.16px;
  text-align: left;
  color: #363636;
}
p {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  padding-bottom: 1%;
  letter-spacing: 0.16px;
  text-align: left;
  color: #363636;
}
h3 {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.14px;
  text-align: left;
  color: #212121;
}
.bankScroll {
  max-height: 21vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.ratingScroll {
  max-height: 11vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
a {
  float: left;
}
h5 {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.14px;
  text-align: left;
  color: #212121;
}
</style>

